<script>
import { Button, Col, Row, Divider } from 'ant-design-vue'
import FormView from '../FormView'
export default {
  props: ['data', 'onSuccess', 'typeData', 'resetDefaultData', 'showAll'],
  data() {
    return {
      isMore: false,
      layout: 'inline',
    }
  },
  mounted() {
    if (this.resetDefaultData) {
      this.$refs._form.formData = this.resetDefaultData
    }
    window.addEventListener('resize', () => {
      if (document.body.clientWidth < 900) {
        if (this.layout !== 'vertical') {
          this.layout = 'vertical'
        }
      } else {
        if (this.layout != 'inline') {
          this.layout = 'inline'
        }
      }
    })
  },
  methods: {
    onSearch() {
      this.$refs._form.sumbit()
    },
    onReset() {
      this.$refs._form.reset()
      // 重置后再赋值，避免重置后无法显示默认值
      if (this.resetDefaultData) {
        this.$refs._form.formData = this.resetDefaultData
      }
      this.$nextTick(() => {
        this.$emit('reset')
      })
    },
    renderMore() {
      return (
        <Col span={8}>
          <a onClick={() => (this.isMore = !this.isMore)} class="header-more">
            {!this.isMore ? '展开' : '收起'}
            <a-icon type={this.isMore ? 'up' : 'down'} style={{ marginLeft: '6px', fontSize: '10px' }} />
          </a>
        </Col>
      )
    },
    getCol() {
      if (this.showAll) {
        return {
          md: 12,
          lg: 12,
          xl: 6,
          xxl: 6,
          xs: 24,
        }
      }
      if (this.isMore) {
        return {
          span: 24,
        }
      } else {
        return {
          md: 24,
          lg: 8,
          xl: 8,
          xxl: 8,
          xs: 24,
        }
      }
    },
    renderRight() {
      const data = [
        {
          name: '查询',
          type: 'default',
          onClick: this.onSearch,
        },
        {
          name: '重置',
          type: 'primary',
          onClick: this.onReset,
        },
      ]
      return (
        <Col
          props={this.getCol()}
          class="search-button"
          style={{
            marginTop: this.isMore ? '10px' : '0px',
            marginBottom: '10px',
          }}
        >
          <Row gutter={20}>
            {data.map((e) => {
              return (
                <Col span={this.data.length > 2 && !this.showAll ? 8 : 12}>
                  <Button type={e.type} onClick={e.onClick} style={{ borderRadius: '4px' }}>
                    {e.name}
                  </Button>
                </Col>
              )
            })}
            {this.data.length > 2 && !this.showAll && this.renderMore()}
          </Row>
        </Col>
      )
    },
    getFormData(data) {
      return data.map((e) => {
        return e
      })
    },
  },
  render() {
    const data = this.showAll || this.isMore ? this.getFormData(this.data) : this.getFormData(this.data.slice(0, 2))
    return (
      <div class="header-box">
        <FormView
          data={data}
          ref={'_form'}
          labelCol={this.layout == 'inline' ? { span: 6 } : {}}
          wrapperCol={this.layout == 'inline' ? { span: 18 } : {}}
          layout={this.layout}
          style={{ width: '100%' }}
          typeData={this.typeData}
          onSuccess={(data) => this.$emit('success', data)}
          onSelectChange={this.onSearch}
        >
          {this.renderRight()}
        </FormView>
        <Divider style={{ margin: 'auto' }} />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.search-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.header-more {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  margin-left: -8px;
}
.header-box {
  margin-top: -17px;
  margin-left: -60px;
}
</style>
